import generateQueryString from '../utils/generateQueryString';

const endpoints = {
  businessProfile: (businessId: string) => `${process.env.API_ROOT_URL}/providers/${businessId}`,
  workplace: (workplaceId: string) => `${process.env.API_ROOT_URL}/booking/${workplaceId}`,
  businessReviews: (businessId: string) => `${process.env.API_ROOT_URL}/providers/${businessId}/reviews`,
  publishBusinessReviews: (reviewId: string) => `${process.env.API_ROOT_URL}/reviews/${reviewId}`,
  search: `${process.env.API_ROOT_URL}/providers/search`,
  config: `${process.env.API_ROOT_URL}/config/categories`,
  petConfig: `${process.env.API_ROOT_URL}/config/pets`,
  user: (id: string) => `${process.env.API_USER_ROOT_URL}/users/${id}`,
  userDetails: (email: string) => `${process.env.API_USER_ROOT_URL}/users?email=${email}`,
  reviewToken: (businessId: string, reviewToken: string) =>
    `${process.env.API_USER_ROOT_URL}/providers/${businessId}/reviews/tokens/${reviewToken}`,
};

export default endpoints;
